/**
 * Browser-safe JWT utilities.
 * Decoding only - the server verifies tokens. Signing is server-only.
 */
export interface UserRolesIds {
  userroleId: number;
  allowView: boolean;
  allowDraft: boolean;
  allowFinalize: boolean;
}
export interface JwtToken {
  userId: number;
  userName: string;
  userFullName: string;
  userTypeId: number;
  userRolesIds: UserRolesIds[];
  associatedId: number; // i.e. CollectorId, WasteReceptionPointId, or CollectionpointId
  associatedId2: null | number; // i.e. null or contributorId
  JwtExpirationDate: Date;
  JwtIssueDate: Date;
}

/**
 * Decode JWT payload without verification (client-safe).
 * Server has already verified the token when issuing it.
 */
function base64UrlDecode(str: string): string {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const pad = base64.length % 4;
  const padded = pad ? base64 + '='.repeat(4 - pad) : base64;
  return decodeURIComponent(
    atob(padded)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
}

export function adminDevToken(): string {
  throw new Error(
    'adminDevToken is server-only. Use a server endpoint or local dev tool to generate tokens.',
  );
}

export function encodeJwtToken(_jwtObj: JwtToken): string {
  throw new Error('encodeJwtToken is server-only. JWT signing must happen on the backend.');
}

export function decodeJwtToken(tokenString: string): JwtToken {
  const parts = tokenString.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid JWT format');
  }
  const payload = JSON.parse(base64UrlDecode(parts[1])) as Record<string, unknown>;
  return {
    ...payload,
    JwtExpirationDate: new Date(Date.parse(String(payload.JwtExpirationDate))),
    JwtIssueDate: new Date(Date.parse(String(payload.JwtIssueDate))),
  } as JwtToken;
}
